import { Add, Edit, Trash } from "iconsax-react";
import DBTable from "../../../../component/global/DBTable/DBTable";
import { t } from "i18next";
import { getLanguageCaption } from "../../../../feedback/helperFunctions";

export default function StateTable(props) {
    const { data, onDelete, onEdit } = props;

    const headers = [
        {
            id: "title",
            title: t("criteria.state.name"),
            gridTemplateColumns: "2fr",
        },
        {
            id: "weight",
            title: t("criteria.weight"),
            gridTemplateColumns: "50px",
        },
        {
            id: "emoji",
            title: t("criteria.state.emoji.just"),
            gridTemplateColumns: "60px",
        },
        {
            id: "options",
            title: t("options"),
            gridTemplateColumns: "70px",
        },
    ].filter((item) =>
        data.criteria_state_type === 3 ? true : item.id !== "emoji"
    );

    const rows = data?.states
        ?.sort((a, b) => a.value - b.value)
        .map((item, index) => {
            return {
                title: (
                    <div className="criteria-states-table-names">
                        {item.name}
                        {item.translates?.map((lang) => (
                            <div>
                                {lang.name} ({getLanguageCaption(lang.language)}
                                )
                            </div>
                        ))}
                    </div>
                ),
                weight: item.value,
                emoji: (
                    <div
                        className="criteria-states-table-emoji"
                        dangerouslySetInnerHTML={{ __html: item.emoji }}
                    ></div>
                ),
                options: (
                    <div className="option-buttons">
                        <Edit
                            size="18"
                            color="#2e71fc"
                            onClick={() => onEdit(index)}
                        />
                        <Trash
                            size="18"
                            color="red"
                            onClick={() => onDelete(index)}
                        />
                    </div>
                ),
            };
        });

    return <DBTable minWidth={500} headers={headers} rows={rows} />;
}
